<template>
	<div class="container">
		<div class="resourceDetailBox">
			<div class="resourceTitle">{{newsData.title}}</div>
			<div class="resourceDataBox">
				<div class="dataList">{{newsData.create_time}}</div>
				<div class="dataList">{{$t('home.source')}}: {{newsData.source}}</div>
			</div>
			<div class="contentBox">
				<div class="contentLeftBox">
					<div class="abstract">
						{{$t('home.abstract')}}：{{newsData.remark}}　
					</div>
					<div class="contentDetail" v-html="xss(newsData.content)"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { localStorage } from '@/utils/storage.js'
	import { formatTimeNum } from '@/utils'
	import * as home from '@/api/home'
	export default {
	  name: 'partyBuildingDetail',
	  data() {
		return {
			newsData: '',
		};
	  },
	  mounted() {
		this.resetScrollTop();
		const id = this.$route.query.id
		;
		this.getNewsDataDetail(id);
	  },
	  methods:{
		resetScrollTop(){
		  this.$nextTick(()=>{
			  document.getElementById("pageMain").scrollTop = 0
		  })
		},
		// 获取党建要闻
		getNewsDataDetail(id){
			const that = this;
			const lang = localStorage.get('language')
			const para = {
				id: id
			}
			home.party_building_read(para).then(res => {
			 if(res.code == 0){
				let data = res.data
				if(lang == 'en'){
					data.create_time = formatTimeNum(data.create_time,'Y-M-D h:m')
				}else{
					data.create_time = formatTimeNum(data.create_time,'Y年M月D日 h:m')
				}
				that.newsData = data
			 }
			}).catch((res) => {
			  ;
			})
		},
		
	  }
	  
	}
</script>
<style>
	.contentDetail p{
		margin: 0;
	}
</style>
<style scoped>
	.resourceDetailBox{
		max-width: 1100px;
		width: 90%;
		margin: 0 auto;
		padding: 40px 0;
	}
	.resourceTitle{
		font-size: 30px;
		font-weight: bold;
		color: #333333;
		text-align: center;
		padding: 20px 0;
	}
	.resourceDataBox{
		width: 100%;
		box-sizing: border-box;
		padding: 10px 10px;
		font-size: 15px;
		color: #333333;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.dataList{
		padding: 0 10px;
	}
	.dataList:last-child{
		border: 0;
	}
	.contentBox{
		width: 100%;
		display: flex;
		justify-content: center;
		padding:30px 0;
	}
	.contentLeftBox{
		width: 100%;
		box-sizing: border-box;
		padding-right: 20px;
	}
	.abstract{
		width: 100%;
		padding: 0 0 20px;
		font-size: 15px;
		color: #333333;
	}
	.contentDetail{
		color: #333333;
		font-size: 15px;
	}
	.contentRightBox{
		width: 300px;
	}
	.newsListBox{
		width: 100%;
	}
	.newsList{
		width: 100%;
		display: flex;
		margin-bottom: 20px;
	}
	.ranking{
		width: 24px;
		height: 24px;
		line-height: 24px;
		font-size: 13px;
		color: #ffffff;
		background: #bfbfbf;
		border-radius: 4px;
		margin-right: 10px;
		text-align: center;
	}
	.topThree{
		background: #32589f;
	}
	.newsContentBox{
		width: calc(100% - 34px);
	}
	.newsTitleText{
		color: #333333;
		font-size: 15px;
		line-height: 24px;
		font-weight: 700;
		margin-bottom: 10px;
		display: -webkit-box;
		overflow: hidden;
		/*! autoprefixer: off; */     
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
	.newsDescText{
		color: #787b8a;
		font-size: 13px;
	}
	
	
	
	
	/* 响应式样式 */
	@media only screen and (max-width: 768px) {
	  .resourceTitle{
		font-size: 24px;
		padding-top: 0;
	  }
	  .resourceDataBox{
		  font-size: 14px;
	  }
	  .resourceDetailBox{
		padding: 20px 0;
	  }
	  .contentBox{
		  flex-wrap: wrap;
		  padding-bottom: 0;
	  }
	  .contentLeftBox{
		  width: 100%;
		  padding: 0;
		  margin-bottom: 40px;
	  }
	  .contentRightBox{
		  width: 100%;
	  }
	}
	@media screen and (min-width: 768px) and (max-width: 999px) { 
		
	}
	@media screen and (min-width: 992px) {  }
	
	@media screen and (min-width: 1200px) {  }
	
	@media screen and (min-width: 1400px) {  }
	
	@media screen and (min-width: 1920px) {  }
</style>